import "../styles/KickOff.css";
import { MdCheckCircle, MdBolt } from "react-icons/md";

export default function KickOff() {
    return (
        <main className="kick">
            <section className="kick-hero">
                <div className="container">
                    <span className="kick-pill">
                        <MdBolt aria-hidden /> Kick-off
                    </span>
                    <h1 className="kick-title">Kick-off Performance</h1>

                    <p className="kick-desc">
                        Ogni risultato nasce da basi solide. Con Kick-off Performance scopri il tuo
                        stato attuale e ricevi indicazioni pratiche su nutrizione, sonno, idratazione
                        e benessere per trasformare energia e performance. <br className="br-lg" />
                        Il primo passo per costruire la tua strategia di successo.
                    </p>
                </div>
            </section>

            <section className="kick-body">
                <div className="container">
                    <h2 className="kick-subtitle">Per partire con il tuo percorso,effettueremo:</h2>

                    <ul className="kick-list" aria-label="Attività incluse nella consulenza">
                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Anamnesi nutrizionale completa</strong> Abitudini alimentari,
                                integrazione e stile di vita.
                            </div>
                        </li>

                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Analisi sportiva personalizzata</strong> Carichi di allenamento,
                                tipologia di disciplina e obiettivi di performance.
                            </div>
                        </li>

                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Valutazione del sonno e del recupero</strong> Qualità del riposo,
                                gestione dello stress e benessere generale.
                            </div>
                        </li>

                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Plicometria certificata</strong> Valutazione delle misure antropometriche della
                                composizione corporea.
                            </div>
                        </li>

                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Valutazione dello stato di idratazione</strong> Per ottimizzare
                                equilibrio idrico e rendimento sportivo.
                            </div>
                        </li>
                    </ul>

                    <p className="kick-outro">
                        Durante il primo incontro del tuo percorso, fisseremo insieme i tuoi obiettivi e programmeremo, in modo strutturato la tua alimentazione ed i tuoi allenamenti.
                        <br />
                        Non ti sentirai mai solo, sarai sempre monitorato in base alle tue esigenze (allenamenti e competizioni).
                    </p>

                    <a href="/contacts" className="btn-ghost">
                        Prenota il tuo Kick-off <span className="arrow">→</span>
                    </a>
                </div>
            </section>
        </main>
    );
}